export default {"src":"/_next/static/media/rectangle_next.e9ab2695.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};